import type { Asserts } from 'yup';

import { baseSchema } from '@/features/Input/inputBaseSchema';
import { genericStoreFactory } from '@/utils/genericStoreFactory/genericStoreFactory';
import { phvSchema } from '@/features/Sparten/phv/schema/schema';

export const inputSchema = phvSchema.concat(baseSchema);

export type InputStore = Asserts<typeof inputSchema>;

export const usePhvInputStore = genericStoreFactory(
  () => inputSchema.getDefault(),
  'PhvInputStore',
);
